import { enumUtil } from "./Enum"
import isNull from "./NullChecking"
import { parse, isBefore } from 'date-fns';

// validation if set date is greater than current date ( for reference view EncounterSearch Date Val )
const CurrentMaxDateValidator = (startDate, type, name) => {
    let maxDate = new Date();
    if (type === enumUtil.enumValidationType.CurrentDate) {
        if(!isNull(startDate)) {
            const parsedStartDate = parse(startDate, 'MM/dd/yyyy', new Date());
            const parsedEndDate = maxDate instanceof Date 
            ? maxDate 
            : parse(maxDate, 'MM/dd/yyyy', new Date());
            console.log("DateValidator",
                isBefore(parsedEndDate, parsedStartDate),
                parsedStartDate,
                parsedEndDate

        )
            if (isBefore(parsedEndDate, parsedStartDate)) {
                return (
                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1 GreaterDate" style={{ display: "block" }}>
                            <i className="bi bi-info-circle-fill fs-10"></i>
                            <p className="fs-9 text-white text">{name || 'Date'} cannot be greater than current date</p>
                        </div>
                )
            }
        }
        return '';
    }

}
export default CurrentMaxDateValidator